import logoFundoEscuro from "@/assets/logo-a-mais_branco-laranja.svg";
import logoFundoClaro from "@/assets/logo-a-mais_preto-laranja.svg";

/** `fundo` é a cor de onde o logo vai: no escuro o "A" é branco, no claro é preto; o "+" é sempre laranja. */
export const Logo = ({ compact = false, fundo = "escuro" }: { compact?: boolean; fundo?: "escuro" | "claro" }) => (
  <div className="flex items-center gap-2">
    <img
      src={fundo === "escuro" ? logoFundoEscuro : logoFundoClaro}
      alt="AceleraMais"
      className="h-7 w-auto shrink-0"
    />
    {!compact && (
      <div className="leading-tight">
        <div className="text-sm font-bold tracking-tight">AceleraMais</div>
        <div className="text-[10px] uppercase tracking-widest opacity-70">Gestão de Pessoas</div>
      </div>
    )}
  </div>
);
